module.exports = __webpack_public_path__ + "img/19.9a937fd5.jpg";